import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { usePermissionsContext } from 'context/PermissionsContext';
import { FilterValuesProps } from 'hooks/useFilter';

export function FormFilterCategoria() {
    const { hasPermission } = usePermissionsContext();

    const [filterCategoria, setFilterCategoria] = useState<FilterValuesProps>({
        property: 'dsCategoriaArquivo',
        operator: 'like',
        value: '',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: hasPermission(['ARQUIVO_CATEGORIA_MODERAR']) ? null : true,
        idProperty: 'vlStatus',
    });

    return (
        <Filter
            filters={[
                { value: filterCategoria, setter: setFilterCategoria },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Nome da categoria"
                    value={filterCategoria.value}
                    onChange={(e) => setFilterCategoria((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            {hasPermission(['ARQUIVO_CATEGORIA_MODERAR']) && (
                <Grid sx={{ flex: 1 }}>
                    <StatusField
                        value={filterStatus.value}
                        onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                    />
                </Grid>
            )}
        </Filter>
    );
}
